<template>
  <div :class="localeClass">
    <div>
      <!-- 打开或收缩查询面板 -->
      <div class="querybar1 child">
        <i
          @click="togglequery"
          style="float: left; cursor: pointer"
          :class="[
            dialogTableVisible
              ? 'bi bi-list mx-1 mt-1'
              : 'bi bi-filter mx-1 mt-1',
          ]"
          :title="$t('queryboardmessage.togglebutton')"
        ></i>
        <i
          style="float: left; cursor: pointer"
          @click="togglecart"
          :class="[
            cartvisible
              ? 'bi bi-cart-fill mx-1 mt-1 mygreen'
              : 'bi bi-cart-fill mx-1 mt-1',
          ]"
          :title="$t('queryboardmessage.cart')"
        ></i>
      </div>
      <!-- 查询按钮，需要先登录 -->
      <div class="querybar2 child">
        <i
          style="cursor: pointer"
          :title="$t('queryboardmessage.query')"
          class="bi bi-search myicon"
          @click="querydata"
        ></i>
      </div>
    </div>

    <transition
      enter-active-class="animate__animated animate__fadeInLeftBig"
      leave-active-class="animate__animated animate__fadeOutLeftBig"
    >
      <div v-show="dialogTableVisible" class="queryparamboard">
        <!-- <el-row justify="start">
          <el-switch
            v-model="dataquerymode"
            class="mt-4 mx-3"
            inactive-text="Product query"
            active-text="Data query"
            active-color="#13ce66"
            inactive-color="#4949ff"
            @change="changequerymode"
          >
          </el-switch>
        </el-row> -->
        <!-- <button data-tip="CLOSE" class="btn myclose">
          <i
            style="cursor: hand"
            class="closebutton bi bi-x-lg"
            @click="togglequery"
          ></i>
        </button> -->
        <!-- <el-divider class="mt-2"></el-divider> -->

        <!-- 空间检索 -->
        <el-row>
          <el-col :span="24">
            <el-tabs class="mx-3" v-model="kongjianmode">
              <el-tab-pane
                :label="$t('queryboardmessage.polygon')"
                name="rectangle"
              >
                <el-row>
                  <el-col :span="20">
                    <el-input
                      :autosize="{ minRows: 5, maxRows: 8 }"
                      type="textarea"
                      disabled
                      v-model="mypolygon"
                    />
                  </el-col>
                  <el-col :span="4" v-model="kongjianmode">
                    <el-row>
                      <div>
                        <!-- 重置空间检索 -->
                        <i
                          @click="oncleanpolygon"
                          style="font-size: 20px; cursor: pointer"
                          class="bi bi-trash-fill mx-2"
                          :title="$t('queryboardmessage.clear')"
                        ></i></div
                    ></el-row>
                    <!-- 多边形，矩形绘制、用户上传shpfile文件 -->
                    <el-row>
                      <!-- 图标使用的bootstrap -->
                      <i
                        @click="ontypechange('Polygon')"
                        style="font-size: 20px; cursor: pointer"
                        class="bi bi-heptagon-fill mx-2"
                        :title="$t('queryboardmessage.drawpolygon')"
                      ></i
                    ></el-row>
                    <el-row
                      ><i
                        @click="ontypechange('Circle')"
                        style="font-size: 20px; cursor: pointer"
                        class="bi bi-square mx-2"
                        :title="$t('queryboardmessage.drawrectangle')"
                      ></i
                    ></el-row>
                    <!-- <el-row
                      ><i
                        @click="uploadvisible = true"
                        style="font-size: 20px; cursor: pointer"
                        class="bi bi-upload mx-2"
                        :title="$t('queryboardmessage.uploadbutton')"
                      ></i
                    ></el-row> -->
                  </el-col>
                </el-row>
              </el-tab-pane>
              <!-- <el-tab-pane
                :label="$t('queryboardmessage.nominatim')"
                name="polygon"
                ><regionquery @selectoneplace="onselectplace"></regionquery
              ></el-tab-pane> -->
            </el-tabs>
          </el-col>
        </el-row>
        <el-divider class="mt-2"></el-divider>

        <!-- 产品级别 -->
        <el-form
          class="mx-3"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item :label="$t('queryboardmessage.producttype')">
            <el-checkbox-group style="float: left" v-model="checkList">
              <el-checkbox
                v-for="(item, index) in productLevelItems"
                :key="index"
                :label="item.label"
                :title="item.title"
                size="medium"
              />
            </el-checkbox-group>
          </el-form-item>
          <!-- 云量,只能输入数字 -->
          <el-form-item :label="$t('queryboardmessage.cloud')">
            <el-input
              size="mini"
              class="mt-1"
              style="width: 120px; float: left"
              v-model="cloudcover"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('queryboardmessage.sensing')">
            <el-date-picker
              v-model="startdate"
              type="date"
              size="mini"
              :style="smallinput"
              placeholder="start date"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
              class="mydatepicker mt-2"
            >
            </el-date-picker>
            <el-date-picker
              v-model="enddate"
              type="date"
              :style="smallinput"
              size="mini"
              placeholder="stop date"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
              class="mydatepicker mt-2 mx-2"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <!-- 日期过滤条件 -->

        <el-divider class="mt-3"></el-divider>

        <!-- 卫星传感器 -->
        <el-row justify="start">
          <h6 class="mt-2 mx-3">{{ $t("queryboardmessage.satellite") }}</h6>
        </el-row>

        <el-tree
          ref="$tree"
          :props="defaultprops"
          node-key="id"
          :data="satellitelist"
          show-checkbox
          @check-change="oncheckchange"
        />
      </div>
    </transition>
  </div>

  <!-- 上传文件对话框属性 -->
  <div class="mydia">
    <el-dialog
      v-model="uploadvisible"
      :show-close="false"
      align-center
      width="500px"
      destroy-on-close="ture"
    >
      <template #title>
        <el-row align:left>
          <h4>{{ $t("queryboardmessage.uploadtitle") }}</h4>
        </el-row>
      </template>

      <template #footer>
        <span class="dialog-footer">
          <el-row class="row-bg" justify="end">
            <i
              style="font-size: 20px; cursor: pointer"
              class="bi bi-x-lg mb-1 mx-3 mt-0"
              @click="uploadvisible = false"
              title="close"
            ></i>
          </el-row>
        </span>
      </template>

      <el-upload
        ref="uploadRef"
        drag
        accept=".zip"
        action="/uploadshpfile"
        :on-success="uploadsuccess"
        :show-file-list="true"
      >
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">
          Drop file here or <em>click to upload</em>
        </div>
        <template #tip>
          <div class="el-upload__tip">
            {{ $t("queryboardmessage.upoladtip") }}
          </div>
        </template>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import "animate.css";
import { getuserprofile } from "../js/userhandler";
//import regionquery from "./regionquery.vue";
import { querydata as querydatahandler, getsatellites } from "../js/querydata";
import {
  reactive,
  toRefs,
  computed,
  onMounted,
  onUnmounted,
  watch,
  ref,
  getCurrentInstance,
} from "vue";
import { ElMessageBox, ElLoading } from "element-plus";
import { useI18n } from "vue-i18n";

export default {
  props: ["polygon"],
  components: {
    //regionquery,
  },
  setup(props, { emit }) {
    const $tree = ref(null);
    const uploadvisible = ref(false);
    const activeName = ref("query");
    const { t } = useI18n();
    const uploadRef = ref(); //上传shp文件的对话框
    const state = reactive({
      checkList: [],
      dialogTableVisible: false, //初始化查询面板不可见
      cartvisible: false, //购物车面板初始化不可见
      startdate: "",
      enddate: "",
      cloudcover: 30,
      kongjianmode: "rectangle",
      mypolygon: props.polygon,
      dataquerymode: true, //二选一
      starttime: "",
      endtime: "",
      activeName: "first",
      tmpstate: "queryboard", //记录刚才的显示状态
      cartchangedflag: false,

      //卫星检索范围，是否应从服务端获取？现在在客户端写死了
      satellitelist: [
        {
          label: "GF1",
          children: [
            {
              id: "GF1_PMS",
              label: "PMS",
            },
            {
              id: "GF1_WFV",
              label: "WFV",
            },
          ],
        },
        {
          label: "GF2",
          children: [
            {
              id: "GF2_PMS",
              label: "PMS",
            },
          ],
        },
        {
          label: "GF3",
          children: [
            {
              id: "GF3_SAR",
              label: "SAR",
            },
          ],
        },
        {
          label: "GF4",
          children: [
            {
              id: "GF4_PMI",
              label: "PMI",
            },
            {
              id: "GF4_PMS",
              label: "PMS",
            },
            {
              id: "GF4_IRS",
              label: "IRS",
            },
            {
              id: "GF4_B1",
              label: "B1",
            },
          ],
        },
        {
          label: "GF5",
          children: [
            {
              id: "GF5_AHSI",
              label: "AHSI",
            },
            {
              id: "GF5_VIMS",
              label: "VIMS",
            },
          ],
        },
        {
          label: "GF6",
          children: [
            {
              id: "GF6_PMS",
              label: "PMS",
            },
            {
              id: "GF6_WFV",
              label: "WFV",
            },
          ],
        },
        {
          label: "GF7",
          activate: true,
          children: [
            {
              id: "GF7_BWD",
              label: "BWD",
            },
            {
              id: "GF7_DLC",
              label: "DLC",
            },
          ],
        },
      ],
    });
    const productLevelItems = [
      { label: "L1A", title: "",value:'L1A' },
      { label: "L2H", title: "Geometrically Terrain-corrected Products",value:'L2H'},
      { label: "L3H", title: "Surface Reflectance Products",value:'L3H'},
    ];//产品级别描述

    const app = getCurrentInstance();
    const { proxy } = getCurrentInstance();
    const localeClass = computed(() => {
      return proxy.$i18n.locale + "font";
    });
    const smallinput = computed(() => {
      if (!state.flag) return "width:120px;height:20px;float:left";
      else return "";
    });

    //上传文件成功，从服务端获取geojson格式的区域，向上层控件发送画该区域消息
    function uploadsuccess(response) {
      if (response.type === undefined) {
        ElMessageBox.alert(t("queryboardmessage.uploadfailed"));
      } else {
        var geom = response;
        ElMessageBox.alert(t("queryboardmessage.uploadsuccessed"));
        emit("selectplace", geom); //向上层控件(querymap)发送消息
      }
      uploadRef.value.clearFiles();
    }

    //查询面板打开关闭开关
    const togglequery = () => {
      // 如果没有登录，弹出登陆界面
      if (app.appContext.config.globalProperties.loginstatus == 0) {
        proxy.$EventBus.emit("showlogindialog");
        return;
      }
      if (state.cartvisible) return; //购物车可见情况下，不能改变查询面板状态，要先关上购物车面板

      state.dialogTableVisible = !state.dialogTableVisible;
      proxy.$EventBus.emit("showresultlist", state.dialogTableVisible);
    };

    //购物车显示面板打开关闭开关
    const togglecart = () => {
      //先检查登录状态
      if (app.appContext.config.globalProperties.loginstatus == 0) {
        proxy.$EventBus.emit("showlogindialog");
        return;
      }
      getuserprofile().then((res) => {
        if (res.status === 200) {
          if (res.data.status == "1") {
            //已经登录了
            state.cartvisible = !state.cartvisible; //切换购物车显示
            proxy.$EventBus.emit("showorhidecart", state.cartvisible);
            if (state.cartvisible) {
              if (state.dialogTableVisible) state.tmpstate = "queryboard";
              else state.tmpstate = "resultlistboard";
              proxy.$EventBus.emit("showresultlist", false);
              state.dialogTableVisible = false;
            } else {
              if (state.tmpstate === "queryboard") {
                state.dialogTableVisible = true;
                proxy.$EventBus.emit("showresultlist", true);
              } else {
                state.dialogTableVisible = false;
                if (state.cartchangedflag) {
                  console.log("cart changed");
                  querydata();
                } else proxy.$EventBus.emit("showresultlist", false);
              }
            }
          } else proxy.$EventBus.emit("showlogindialog"); //显示登录
        }
      });
    };

    const userdrawactiveflag = computed(() => {
      //该计算属性判断是否用户可以画矩形
      if (state.dialogTableVisible && state.dataquerymode) return true;
      else return false;
    });
    watch(
      () => props.polygon,
      () => {
        //Vue的一个BUG，父组件传进来props,state中绑定的变量应该及时变化，但是必须用watch监听变化，然后手工设置才行
        state.mypolygon = props.polygon;
      }
    );

    watch(
      () => userdrawactiveflag.value,
      () => {
        if (userdrawactiveflag.value) emit("toggledraw", true);
        else emit("toggledraw", false);
      }
    );

    onMounted(() => {
      //设置初始时间
      var myDate = new Date();
      state.enddate = myDate.Format("yyyy-MM-dd");
      myDate.setDate(myDate.getDate() + -5);
      state.startdate = myDate.Format("yyyy-MM-dd");
      proxy.$EventBus.on("onlogin", onlogin); //注册用户登入,显示查询面板
      proxy.$EventBus.on("onlogout", onlogout); //退出登录需要清空面板
      proxy.$EventBus.on("cartchanged", onccartchanged);

      state.satellitelist.forEach((node) => {
        node.disabled = true;
        node.children.forEach((element) => {
          element.disabled = true;
        });
      });
      //获取哪些卫星有数据的列表
      getsatellites().then((res) => {
        if (res.status === 200) {
          if (res.data.status == "1") {
            const labelsToSearch = res.data.satellites;
            labelsToSearch.forEach((labelToSearch) => {
              // 查找指定 label 的对象在数组中的索引
              state.satellitelist.forEach((node) => {
                if (node.label === labelToSearch) {
                  node.disabled = false;
                  node.children.forEach((element) => {
                    element.disabled = false;
                  });
                }
              });
            });

            //起始时间设置为数据库中数据的最早接收时间
            state.startdate = res.data.earliest;
          }
        }
      });
    });

    onUnmounted(() => {
      proxy.$EventBus.off("onlogout");
      proxy.$EventBus.off("onlogin");
      proxy.$EventBus.off("cartchanged");
    });

    const onccartchanged = () => {
      state.cartchangedflag = true;
    };

    //检索数据函数,用户点击查询面板上的查询按钮时调用该函数
    const querydata = () => {
      try {
        if (app.appContext.config.globalProperties.loginstatus == 0) {
          proxy.$EventBus.emit("showlogindialog");
          return;
        }
        getuserprofile().then((res) => {
          if (res.status === 200) {
            //如果已经登录执行数据检索
            if (res.data.status == "1") {
              if (state.dataquerymode) {
                if (state.startdate == null || state.enddate == null) {
                  ElMessageBox.alert("Please input start date");
                  return;
                }

                let queryparam = {};
                let tmpproductlevel = [];
                queryparam.pageNo = 1;
                queryparam.pagesize = 10; //初始化结果页面大小
                queryparam.startdate = state.startdate;
                queryparam.enddate = state.enddate+" 23:59:59";
                queryparam.source = $tree.value.getCheckedKeys(true).join(",");
                queryparam.geom = state.mypolygon;
                //按照数据字典将产品的显示等级翻译为数据库中对应的产品等级
                for (let i = 0; i < state.checkList.length; i++) {
                   productLevelItems.forEach(item=>{
                    if( item.label===state.checkList[i]) tmpproductlevel.push(item.value)
                  })
                }
                console.log(tmpproductlevel);
                queryparam.productlevel = tmpproductlevel.join(",");
                queryparam.cloudcover = state.cloudcover;
                console.log(ElLoading);

                querydatahandler(queryparam).then((res) => {
                  if (res.status === 200) {
                    //  loadingInstance.close();
                    let param = res.data;
                    if (param.status == "1") {
                      //查询正常返回结果
                      state.dialogTableVisible = false; //隐藏查询面板
                      //发送显示查询结果消息，由结果面板捕获消息，param：结果json
                      param.queryobj = queryparam;
                      proxy.$EventBus.emit("showresultlist", param);
                    } else {
                      console.log("serve error");
                    }
                  }
                  //  else loadingInstance.close();
                });
              }
            } else proxy.$EventBus.emit("showlogindialog");
          }
        });
      } catch (err) {
        console.log(err);
      }
    };

    const onlogout = () => {
      oncleanpolygon();
      state.dialogTableVisible = false;
    };
    const onlogin = () => {
      state.dialogTableVisible = true;
    };
    // 多边形类型变化,鼠标选择不同多边形绘制类型
    function ontypechange(type) {
      emit("changepolygontype", type);
    }
    //重置多边形
    function oncleanpolygon() {
      emit("resetpolygon");
    }
    function changequerymode() {
      console.log("changequery");
    }
    function oncheckchange() {
      //调用tree控件，获得选中对象的id列表
      $tree.value.getCheckedKeys(true);
    }
    Date.prototype.Format = function (fmt) {
      //author: meizz
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    };

    function onselectplace(geom) {
      //向querymap发送用户选择了一个区域事件。geom是Geojson类型的geomerty
      emit("selectplace", geom);
    }

    return {
      querydata,
      togglequery,
      uploadsuccess,
      togglecart,
      ...toRefs(state),
      smallinput,
      changequerymode,
      oncheckchange,
      $tree,
      uploadRef,
      activeName,
      ontypechange,
      oncleanpolygon,
      onselectplace,
      uploadvisible,
      localeClass,
      productLevelItems,
    };
  },
};
</script>

<style scoped>
.querybar1 {
  position: relative;
  top: 10px;
  left: 25px;
  width: 500px;
  height: 30px;
  background: white;
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.7);
  z-index: auto;
  overflow-y: auto;
}
.querybar2 {
  position: relative;
  top: 10px;
  left: 25px;
  width: 35px;
  height: 30px;
  background: rgb(47, 43, 43);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.7);
  z-index: auto;
  overflow-y: auto;
}

.queryparamboard {
  position: relative;
  top: 15px;
  left: 25px;
  width: 500px;
  height: 75vh;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.7);
  z-index: auto;
  overflow-y: auto;
}
.myimg {
  position: absolute;
  left: 15px;
  top: 10px;
  transition: all 0.8s;
}
.myclose {
  position: absolute;
  right: 5px;
  top: 5px;
}
.smalllabel {
  color: rgb(12, 94, 141);
  font-size: small;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 100;
}
.myicon {
  font-size: 15px;
  background: rgb(47, 47, 40);
  color: white;
  margin: 0px;
}
.mygreen {
  color: green;
}
.child {
  display: inline-block;
}
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: none;
  box-shadow: none;
}
/* el-form行间距 */
.el-form-item {
  margin-bottom: 0px;
}

.animate__animated.animate__fadeInLeftBig {
  --animate-duration: 500ms;
}
.animate__animated.animate__fadeOutLeftBig {
  --animate-duration: 1500ms;
}

:deep(.el-dialog .el-dialog__body) {
  padding: 1vh;
}
:deep(.el-dialog .el-dialog__footer) {
  padding-top: 15px;
}
:deep(.el-upload-dragger) {
  width: 450px;
}
/* 老挝语字体 */
.lwfont {
  font-family: "Saysettha OT", sans-serif;
}

/* 英语字体 */
.enfont {
  font-family: "Arial", sans-serif;
}
</style>

